import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c(VMenu,{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c(VBtn,_vm._g({attrs:{"color":"black","text":"","icon":"","small":""}},on),[_c(VIcon,[_vm._v("mdi-dots-vertical")])],1)]}}])},[_c(VList,_vm._l((_vm.items),function(item,index){return _c(VListItem,{key:index,on:{"click":function($event){return _vm.$emit('menuAction', item.action, _vm.id)}}},[_c(VListItemTitle,[_vm._v(_vm._s(item.text))])],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }